import { c as _c } from "react/compiler-runtime";
import { PortalSimple } from '@components/portal-simple/PortalSimple';
import Switch from '@components/switch/Switch';
import arrowIcon from '@images/svg/linkArrow.svg';
import cn from 'classnames';
import { useEffect } from 'react';
import Svg from 'react-inlinesvg';
import { DropDownCalc } from '../dropdown/Dropdown';
import styles from './ComparingModal.module.scss';
export const ComparingModal = t0 => {
  const $ = _c(37);
  const {
    isVisible,
    comparings,
    sortingProgram,
    onClose,
    onAfterClose,
    onClean,
    onSort,
    onOpenForm
  } = t0;
  let t1;
  if ($[0] !== isVisible || $[1] !== onAfterClose) {
    t1 = () => {
      if (!isVisible) {
        const timer = setTimeout(() => onAfterClose?.(), 500);
        return () => clearTimeout(timer);
      }
    };
    $[0] = isVisible;
    $[1] = onAfterClose;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isVisible) {
    t2 = [isVisible];
    $[3] = isVisible;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== comparings.length || $[6] !== onClean || $[7] !== onClose) {
    t3 = param => {
      onClean(param);
      if (comparings.length <= 1 || param === "cleanAll") {
        onClose();
      }
    };
    $[5] = comparings.length;
    $[6] = onClean;
    $[7] = onClose;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const onCleanPrograms = t3;
  let t4;
  if ($[9] !== isVisible) {
    t4 = cn(styles.overlay, {
      [styles.overlayVisible]: isVisible
    });
    $[9] = isVisible;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className={styles.title}>Сравнение ипотечных программ</p>;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== onClose) {
    t6 = <div className={styles.top}>{t5}<button className={styles.close} onClick={onClose} aria-label={"\u0417\u0430\u043A\u0440\u044B\u0442\u044C"} /></div>;
    $[12] = onClose;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className={styles.revertSvg}><Svg src={arrowIcon.src} /></span>;
    t8 = <span>Вернуться к ипотечному калькулятору</span>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t7 = $[14];
    t8 = $[15];
  }
  let t9;
  if ($[16] !== onClose) {
    t9 = <div className={styles.revert} onClick={onClose}>{t7}{t8}</div>;
    $[16] = onClose;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== onSort || $[19] !== sortingProgram) {
    t10 = <DropDownCalc list={sortingProgram} onSelect={onSort} />;
    $[18] = onSort;
    $[19] = sortingProgram;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t9) {
    t11 = <div className={styles.toolbar}>{t9}{t10}</div>;
    $[21] = t10;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== comparings || $[25] !== onCleanPrograms || $[26] !== onOpenForm) {
    t12 = comparings?.length > 0 && <div className={styles.content}><div className={styles.comparingsWrapper}>{comparings.map(program => {
          const {
            interestRateActual,
            creditTimeEnd,
            monthPayment
          } = program.aggregateValues;
          return <div key={program.guid} className={styles.program}><div className={styles.title}>{program.name}</div><div className={styles.rate}>от {interestRateActual}%</div><div className={styles.credit}>до {creditTimeEnd} лет</div><div className={styles.payment}>{monthPayment.toLocaleString("ru-RU")} ₽</div><div className={styles.consideration}>3 дня</div><Switch handleSwitch={onOpenForm} switchText={"\u041F\u043E\u0434\u0430\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443"} someStyles={styles.cta} /><div className={styles.delete} onClick={() => onCleanPrograms(program)}><svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 18C2.45 18 1.97933 17.8043 1.588 17.413C1.19667 17.0217 1.00067 16.5507 1 16V3H0V1H5V0H11V1H16V3H15V16C15 16.55 14.8043 17.021 14.413 17.413C14.0217 17.805 13.5507 18.0007 13 18H3ZM13 3H3V16H13V3ZM5 14H7V5H5V14ZM9 14H11V5H9V14Z" fill="#1C1C1C" /></svg></div></div>;
        })}</div></div>;
    $[24] = comparings;
    $[25] = onCleanPrograms;
    $[26] = onOpenForm;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== comparings.length || $[29] !== onCleanPrograms) {
    t13 = comparings?.length > 0 && <div className={styles.deleteAll}><Switch key="cleanAll" handleSwitch={() => onCleanPrograms("cleanAll")} switchText={"\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0432\u0441\u0451"} testId="cleanComparingsBtn" /></div>;
    $[28] = comparings.length;
    $[29] = onCleanPrograms;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t11 || $[32] !== t12 || $[33] !== t13 || $[34] !== t4 || $[35] !== t6) {
    t14 = <PortalSimple><div className={t4}>{t6}{t11}{t12}{t13}</div></PortalSimple>;
    $[31] = t11;
    $[32] = t12;
    $[33] = t13;
    $[34] = t4;
    $[35] = t6;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  return t14;
};